import React, {useContext} from 'react'
import FormTranslationContext from "context/FormTranslationContext";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import getObjectValue from "libs/getObjectValue";
import GridBlock from "../../../../GridBlock";
import NoticeTypography from "../../components/inputs/NoticeTypography";
import {Collapse} from "@material-ui/core";
import NoticeNumericInput from "../../components/inputs/NoticeNumericInput";
import NoticeDateInput from "../../components/inputs/NoticeDateInput";


function ContractDivided(
    {
        id,
        formikProps,
        index
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const realizationPeriod = gVal("realizationPeriod");
    const tenderCompletedWithContract = getObjectValue("form.tenderCompletionData.divided." + index + ".tenderCompletionType", formikProps.values, null) === "zawarcieUmowy";
    const {getDict} = useContext(FormTranslationContext)

    return (<>
        <GridBlock justify="space-evenly">
            <NoticeTypography formTrKey={id}>: {index + 1}</NoticeTypography>
        </GridBlock>

        <NoticeDateInput
            formikProps={formikProps}
            id={gId("contractDate")}
            required={tenderCompletedWithContract}
        />

        <NoticeNumericInput
            formikProps={formikProps}
            id={gId("contractValue")}
            required={tenderCompletedWithContract}
        />

        <NoticeGlossaryInput
            id={gId("contractCurrency")}
            formikProps={formikProps}
            items={getDict("SL.MO.043")}
            required={tenderCompletedWithContract}
        />

        <NoticeGlossaryInput
            formikProps={formikProps}
            id={gId("purchaserRealizationRequirements")}
            items={getDict("SL.MO.022")}
            required={false}
            multiple
        />

        <NoticeGlossaryInput
            formikProps={formikProps}
            id={gId("realizationPeriod")}
            items={getDict("ENUM.025")}
            required={tenderCompletedWithContract}
        />

        <Collapse in={realizationPeriod === "DateFromTo"}>
            <NoticeDateInput
                formikProps={formikProps}
                id={gId("realizationPeriodDateFrom")}
                required={tenderCompletedWithContract}
            />
        </Collapse>

        <Collapse
            in={realizationPeriod === "DateFromTo" || realizationPeriod === "DateTo"}>
            <NoticeDateInput
                formikProps={formikProps}
                id={gId("realizationPeriodDateTo")}
                required={tenderCompletedWithContract}
            />
        </Collapse>

        <Collapse
            in={realizationPeriod === "NumberOfDays" || realizationPeriod === "NumberOfMonths"}>
            <NoticeNumericInput
                formikProps={formikProps}
                id={gId("realizationPeriodAmount")}
                required={tenderCompletedWithContract}
            />
        </Collapse>
    </>)
}

ContractDivided.propTypes = {};

export default ContractDivided;
